<section class="featured-product">
  <div class="featured-product__inner">

    <!-- LEFT: Product Info -->
    <div class="featured-product__info">

      <span class="featured-product__eyebrow">Producto Destacado</span>

      <!-- Badges -->
      <div class="featured-product__badges">
        @if (product().isNew) {
          <app-badge variant="new">Novedad</app-badge>
        }
        @if (isOutOfStock()) {
          <app-badge variant="sold-out">Agotado</app-badge>
        }
        @if (product().isPreSale) {
          <app-badge variant="pre-sale">Pre-venta</app-badge>
        }
      </div>

      <h2 class="featured-product__name">{{ product().name }}</h2>

      <hr class="featured-product__divider" />

      <!-- Price section (oculto en agotados — el back no envía precio) -->
      @if (!isOutOfStock()) {
        <div class="featured-product__price-section">
          <div class="featured-product__price-row">
            <span class="featured-product__price">{{ formattedPrice() }}</span>
            @if (product().isOnSale && discountPercent() > 0) {
              <app-badge variant="sale">-{{ discountPercent() }}%</app-badge>
            }
          </div>
          @if (product().isOnSale && product().originalPrice != null) {
            <span class="featured-product__original-price">{{ formattedOriginalPrice() }}</span>
          }
        </div>

        <hr class="featured-product__divider" />
      }

      <!-- Meta section: solo para singles -->
      @if (isSingle()) {
        <div class="featured-product__meta-section">
          <div class="featured-product__set-row">
            @if (setLink(); as link) {
              <a
                class="featured-product__set featured-product__set--link"
                [routerLink]="link"
              >{{ product().setName }}@if (product().setCode) { · {{ product().setCode }}}</a>
            } @else {
              <span class="featured-product__set">{{ product().setName }}@if (product().setCode) { · {{ product().setCode }}}</span>
            }
            <app-variant-badge [variant]="product().variant">
              {{ variantLabel() }}
            </app-variant-badge>
          </div>

          <div class="featured-product__stats-list">
            @if (product().rarity) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Rareza</span>
                <span class="featured-product__stat-value">{{ product().rarity }}</span>
              </div>
            }
            @if (product().cardType) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Tipo</span>
                <span class="featured-product__stat-value">{{ product().cardType }}</span>
              </div>
            }
            @if (product().hp) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">HP</span>
                <span class="featured-product__stat-value">{{ product().hp }}</span>
              </div>
            }
            @if (product().stage) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Etapa</span>
                <span class="featured-product__stat-value">{{ product().stage }}</span>
              </div>
            }
            <!-- Mecánicas de juego (OP/MTG). Render plano label/valor para
                 mantener el bloque destacado compacto — los chips de color y
                 subtype se reservan para PDP y quickview. -->
            @if (product().color) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Color</span>
                <span class="featured-product__stat-value">{{ product().color }}</span>
              </div>
            }
            @if (product().mana_cost) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Maná</span>
                <span class="featured-product__stat-value">{{ product().mana_cost }}</span>
              </div>
            }
            @if (product().cost) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Coste</span>
                <span class="featured-product__stat-value">{{ product().cost }}</span>
              </div>
            }
            @if (powerToughness(); as pt) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">{{ powerToughnessLabel() }}</span>
                <span class="featured-product__stat-value">{{ pt }}</span>
              </div>
            }
            @if (product().counter) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Counter</span>
                <span class="featured-product__stat-value">{{ product().counter }}</span>
              </div>
            }
            @if (product().card_attribute) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Atributo</span>
                <span class="featured-product__stat-value">{{ product().card_attribute }}</span>
              </div>
            }
            @if (product().subtype) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Subtipo</span>
                <span class="featured-product__stat-value">{{ product().subtype }}</span>
              </div>
            }
            @if (conditionTone(); as tone) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Estado</span>
                <app-badge [variant]="tone">{{ conditionLabel() }}</app-badge>
              </div>
            }
            @if (formattedLanguage(); as language) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Idioma</span>
                <span class="featured-product__stat-value">{{ language }}</span>
              </div>
            }
            @if (!isOutOfStock() && !isLowStock()) {
              <div class="featured-product__stat-item">
                <span class="featured-product__stat-label">Stock</span>
                <span class="featured-product__stat-value">{{ product().stock }}</span>
              </div>
            }
          </div>
        </div>
      }

      @if (product().shortDescription) {
        <p class="featured-product__short-description">{{ product().shortDescription }}</p>
      }

      @if (isLowStock()) {
        <span class="featured-product__low-stock">Últimas {{ product().stock }} unidades</span>
      }

      <hr class="featured-product__divider" />

      <!-- Footer: quantity + CTA + view details -->
      <div class="featured-product__footer">
        @if (product().isPreSale && !isOutOfStock()) {
          <!-- Precompra (D25): CTA directa al modal, sin selector de cantidad
               ni carrito. El modal pide la cantidad (prepurchase_limit). -->
          <div class="featured-product__cta featured-product__cta--full">
            <app-button variant="primary" size="lg" (click)="onReserve()">
              <span class="featured-product__btn-content">
                <app-icon [icon]="calendarIcon" [size]="16" />
                <span>Reservar</span>
              </span>
            </app-button>
          </div>
        } @else if (isPrepurchaseSoldOut()) {
          <div class="featured-product__cta featured-product__cta--full">
            <app-button
              variant="primary"
              size="lg"
              class="btn-sold-out"
              [appTooltip]="prepurchaseSoldOutMessage"
              (click)="onPrepurchaseSoldOutClick()"
            >
              <span class="featured-product__btn-content">
                <app-icon [icon]="calendarIcon" [size]="16" />
                <span>Precompra Agotada</span>
              </span>
            </app-button>
          </div>
        } @else if (!isOutOfStock()) {
          <div class="featured-product__add-row">
            <div class="featured-product__quantity-row">
              <span class="featured-product__qty-label">Cantidad:</span>
              <div class="featured-product__quantity">
                <button
                  class="featured-product__qty-btn"
                  [disabled]="!canDecrement()"
                  (click)="decrement()"
                  aria-label="Reducir cantidad"
                >
                  <app-icon [icon]="minusIcon" [size]="16" />
                </button>
                <span class="featured-product__qty-value">{{ quantity() }}</span>
                <button
                  class="featured-product__qty-btn"
                  [disabled]="!canIncrement()"
                  (click)="increment()"
                  aria-label="Aumentar cantidad"
                >
                  <app-icon [icon]="plusIcon" [size]="16" />
                </button>
              </div>
            </div>

            <div class="featured-product__cta">
              <app-button variant="primary" size="lg" (click)="onAddToCart()">
                <span class="featured-product__btn-content">
                  <app-icon [icon]="cartIcon" [size]="16" />
                  <span>Agregar al carrito</span>
                </span>
              </app-button>
            </div>
          </div>
        } @else {
          <div class="featured-product__cta featured-product__cta--full">
            <app-button variant="ghost" size="lg" (click)="onNotify()">
              <span class="featured-product__btn-content">
                <app-icon [icon]="bellIcon" [size]="16" />
                <span>Avisarme cuando esté disponible</span>
              </span>
            </app-button>
          </div>
        }

        <button class="featured-product__view-details" (click)="onZoomOpen()">
          Ver ficha completa
        </button>
      </div>

    </div>

    <!-- RIGHT: Product Image -->
    <div class="featured-product__image-wrap" [attr.data-variant]="product().variant">
      <img
        class="featured-product__image"
        [src]="product().imageUrl"
        [alt]="product().name"
      />
    </div>

  </div>
</section>
